module.exports = __webpack_public_path__ + "img/BRCA3_Endothelial.529784bf.png";